import { Link, useRouteLoaderData } from "@remix-run/react"
import dayjs from "dayjs"
import { cn } from "~/utils/shadecn"
import { ActionPopup } from "./dialogs"
import Typography from "./typography"
import { useEffect, useState } from "react"

export default function PromotionBanner() {
  const { user, sub } = useRouteLoaderData("root")
  const [open, setOpen] = useState(false)

  const dismissPopup = (open: boolean) => {
    console.log("dismisspopup", open)
    setOpen(false)
    let expiration_date = new Date()
    expiration_date.setFullYear(expiration_date.getFullYear() + 1)
    document.cookie = "dismissPopup=holiday2025; path=/; expires=" + expiration_date.toUTCString()
  }

  useEffect(() => {
    if (document.cookie.indexOf("dismissPopup=holiday2025") === -1) {
      setOpen(true)
    }
  }, [])

  return (
    <div
      className={cn(
        "relative bg-primary/90 text-center text-zinc-50 max-w-4xl mx-auto py-1 px-2 md:py-3 md:px-4 mb-4 rounded-lg"
      )}>
      {user ?
        <>
          {sub ?
            <>
              {sub.Package.Tag === "binge-annual" ?
                <>
                  <p>
                    <Link to="/holiday-bundle">Get 120 credits that never expire!</Link>
                  </p>
                  <ActionPopup
                    open={open}
                    onOpenChange={dismissPopup}
                    title="We Are Thankful for You"
                    content={
                      <Typography>
                        <p>Get 120 credits that never expire!</p>
                        <p>Offer ends Monday.</p>
                      </Typography>
                    }
                    buttonText="Buy Now"
                    buttonURL="/holiday-bundle"
                  />
                </>
              : <>
                  {sub.Package.Tag.includes("annual") ?
                    <>
                      <p>
                        <Link to="/subscribe">Get 20 free credits!</Link>
                      </p>
                      <ActionPopup
                        open={open}
                        onOpenChange={dismissPopup}
                        title="We Are Thankful for You"
                        content={
                          <Typography>
                            <p>Get 20 free credits when you upgrade your subscription!</p>
                            <p>Offer ends Monday.</p>
                          </Typography>
                        }
                        buttonText="Buy Now"
                        buttonURL="/subscribe"
                      />
                    </>
                  : <>
                      <p>
                        <Link to="/subscribe">Get 10 free credits!</Link>
                      </p>
                      <ActionPopup
                        open={open}
                        onOpenChange={dismissPopup}
                        title="We Are Thankful for You"
                        content={
                          <Typography>
                            <p>Get 10 free credits when you upgrade to an annual subscription!</p>
                            <p>Offer ends Monday.</p>
                          </Typography>
                        }
                        buttonText="Buy Now"
                        buttonURL="/subscribe"
                      />
                    </>
                  }
                </>
              }
            </>
          : <>
              <p>
                <Link to="/subscribe">Get 10 free credits!</Link>
              </p>
              <ActionPopup
                open={open}
                onOpenChange={dismissPopup}
                title="We Are Thankful for You"
                content={
                  <Typography>
                    <p>Get 10 free credits when you subscribe to an annual subscription!</p>
                    <p>Offer ends Monday.</p>
                  </Typography>
                }
                buttonText="Buy Now"
                buttonURL="/subscribe"
              />
            </>
          }
        </>
      : <Link to="/register" className="text-balance hover:underline text-xs sm:text-sm">
          <b>Sign up now to get one week of subscriber benefits for free</b>
        </Link>
      }
    </div>
  )
}
